import { IMAGE_ADS, INTERSTITIAL_ADS, type ImageAdConfig, type InterstitialAdConfig } from "@/config/houseAds";

function readCounter(key: string): number {
  const raw = typeof window !== "undefined" ? window.localStorage.getItem(key) : null;
  const n = raw ? parseInt(raw, 10) : 0;
  return Number.isFinite(n) ? n : 0;
}

function writeCounter(key: string, n: number) {
  try {
    window.localStorage.setItem(key, String(n));
  } catch {
    // localStorage indisponível (modo privado etc.) — sem problema, só perde a persistência.
  }
}

function nextFrom<T>(key: string, list: T[]): T {
  const counter = readCounter(key);
  const item = list[counter % list.length];
  writeCounter(key, counter + 1);
  return item;
}

/** Próximo anúncio de imagem (Dashboard / lista de lançamentos) — sequencial, nunca aleatório. */
export function nextImageAd(): ImageAdConfig {
  return nextFrom("cn_ad_rotation_index", IMAGE_ADS);
}

/** Próximo anúncio em vídeo de tela cheia (a cada 2 lançamentos criados) — sequencial, nunca aleatório. */
export function nextInterstitialAd(): InterstitialAdConfig {
  return nextFrom("cn_interstitial_rotation_index", INTERSTITIAL_ADS);
}
